import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Router } from '@angular/router';
import { SubscriptionService } from '../services/subscription.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

/**
 * Interfaces
 */
interface ILeftNavExpandStatus {
  isFacilityExpanded: boolean;
  isEquipmentSettingsExpanded: boolean;
  isSoftwareExpanded: boolean;
  isMembersExpanded: boolean;
  isTrainingExpanded: boolean;
}

/**
 * Component
 */
@Component({
  selector: 'app-left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.css'],
})
export class LeftNavigationComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  leftNavExpandStatus: ILeftNavExpandStatus;
  public currentFacility: FacilityObject;

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private router: Router,
    private _subscriptionService: SubscriptionService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _loader: HaloLoaderService,
  ) {
    this.getRootScopeData();
  }
  upgradeURL: string;
  manageSubscriptionURL: string;
  isLeftMenuVisible = false;
  showStorePage = false;
  showHideLeftMenu(): void {
    this.isLeftMenuVisible = !this.isLeftMenuVisible;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit() {
    this.getLeftNavExpandStatus();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this.showorhideStore();
    });
  }
  showorhideStore(){
    if (this.currentFacility.summary.isProEnabled === 'true') {
      this.showStorePage = true;
    } else {
      this.showStorePage = false;
    }
  }
  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }
  tryToMoveAwayFromCurrentPage(path: string): boolean {
    this.showHideLeftMenu();
    this.rootScopeData.pathToNavigate = path;
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      return false;
    } else {
      if (path === 'purchasePlan') {
        this.goToPurchasePage();
      } else if (this.rootScopeData.pathToNavigate.indexOf('app.html') >= 0) {
        window.location.href = this.rootScopeData.pathToNavigate;
      } else if (this.rootScopeData.pathToNavigate !== this.router.url) {
        window.location.href = 'halo.html#' + this.rootScopeData.pathToNavigate;
      }
      return true;
    }
  }

  getLeftNavExpandStatus() {
    const leftNavStatusLocalStorage = localStorage.getItem('lefNavigationExpandStatus');
    const leftNavCurrentExpandStatus: ILeftNavExpandStatus = leftNavStatusLocalStorage
      ? JSON.parse(leftNavStatusLocalStorage)
      : null;

    if (!leftNavCurrentExpandStatus) {
      this.leftNavExpandStatus = {
        isFacilityExpanded: false,
        isEquipmentSettingsExpanded: false,
        isSoftwareExpanded: false,
        isMembersExpanded: false,
        isTrainingExpanded: false,
      };
    } else {
      this.leftNavExpandStatus = leftNavCurrentExpandStatus;
    }
  }

  setLeftNavExpandStatus(handler: string) {
    setTimeout(() => {
      if (handler === 'facility') {
        this.leftNavExpandStatus.isFacilityExpanded = !this.leftNavExpandStatus.isFacilityExpanded;
      } else if (handler === 'equipmentSetting') {
        this.leftNavExpandStatus.isEquipmentSettingsExpanded = !this.leftNavExpandStatus.isEquipmentSettingsExpanded;
      } else if (handler === 'software') {
        this.leftNavExpandStatus.isSoftwareExpanded = !this.leftNavExpandStatus.isSoftwareExpanded;
      } else if (handler === 'members') {
        this.leftNavExpandStatus.isMembersExpanded = !this.leftNavExpandStatus.isMembersExpanded;
      } else if (handler === 'training') {
        this.leftNavExpandStatus.isTrainingExpanded = !this.leftNavExpandStatus.isTrainingExpanded;
      }

      localStorage.setItem('lefNavigationExpandStatus', JSON.stringify(this.leftNavExpandStatus));
    }, 500);
  }

  goToPurchasePage() {
    //this._amplitudeAnalytics.logEvent('Store');
    if (this.currentFacility.summary.isSubscriptionBannerEnabled === 'true') {
      // TODO: Make it as promise.
      this._loader.startProcess();
      this._facilityService
        .setFacilityUserPreference('isSubscriptionBannerEnabled', false)
        .then()
        .finally(() => {
          this._subscriptionService.getToken();
          this._loader.endProcess();
        });
    } else {
      this._subscriptionService.getToken();
    }
  }
}
